import React, {
  useMemo,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Col, Row } from "@neumetric/blueprint-lib/components";

function buildTocTree(items) {
  const tree = [];
  const stack = [];

  items.forEach((item) => {
    const node = {
      ...item,
      children: [],
    };

    const level = Number(item.level);

    while (stack.length > level) {
      stack.pop();
    }

    if (stack.length === 0) {
      tree.push(node);
    } else {
      stack[stack.length - 1].children.push(node);
    }

    stack.push(node);
  });

  return tree;
}

function TocNode({ node, onSelect }) {
  const [expanded, setExpanded] = useState(true);

  const hasChildren = node.children.length > 0;

  const handleClick = () => {
    if (hasChildren) {
      setExpanded((prev) => !prev);
    }

    onSelect?.(node);
  };

  return (
    <div>
      <Row
        onClick={handleClick}
        align="center"
        className="pointer pb-3 pt-3 pl-8 pr-8"
        style={{ gap: 6, borderRadius: 4, userSelect: "none" }}
      >
        <span style={{ width: 14 }}>
          {hasChildren ? (expanded ? "▼" : "▶") : ""}
        </span>

        <span className="ff-exo2 fs-14 fw-400 text-filled">{node.title}</span>
      </Row>

      {expanded && hasChildren && (
        <div style={{ marginLeft: 20 }}>
          {node.children.map((child) => (
            <TocNode key={child.id} node={child} onSelect={onSelect} />
          ))}
        </div>
      )}
    </div>
  );
}

export const DocumentTabs = forwardRef(({ items, onSelect }, ref) => {
  const [localItems, setLocalItems] = useState(items);
  const tree = useMemo(() => buildTocTree(localItems), [localItems]);
  useImperativeHandle(ref, () => ({
    setItems: (newItems) => {
      setLocalItems(newItems);
    },
  }));
  return (
    <Col className="h-100 overflow-hide" style={{ width: 360 }}>
      <Col className="w-100 pa-8 doc-tabs-header mb-8">
        <span className="fs-16 fw-600 ff-exo2 text-filled">Document Tabs</span>
      </Col>
      <Col className="w-100 overflow-auto flex-auto">
        {tree.map((node) => (
          <TocNode key={node.id} node={node} onSelect={onSelect} />
        ))}
      </Col>
    </Col>
  );
});
